import React from 'react';
import { List, Icon, Popup } from 'semantic-ui-react';
import './index.scss';
import DYLAvatar from './DYLAvatar';

const UserAvatar = ({ user_id, showAllUsersList, usersList, usersLimit }) => {
    let users = [];
    for (let x = 0; (!showAllUsersList && (x < usersLimit && x < usersList.length)) || (showAllUsersList && x < usersList.length); x++) {
        const isInactive = usersList[x].inactive;
        users.push((
            <Popup
                key={usersList[x].id}
                trigger={(
                    <List className='UserAvatar'>
                        <List.Item key={usersList[x].id}>
                            <List.Icon verticalAlign='middle'>
                                <DYLAvatar popup={false} inactive={isInactive} name={`${usersList[x].first_name} ${usersList[x].last_name}`} maxInitials={2} round size='3em' />
                            </List.Icon>
                            <List.Content>
                                <List.Header>
                                    <span className={`UserAvatar__name${isInactive ? '--inactive' : ''}`}>{usersList[x].first_name} {usersList[x].last_name}{usersList[x].id === user_id && " (me)"}</span>
                                </List.Header>
                                <List.Description className={`UserAvatar__desc${isInactive ? '--inactive' : ''}`}>
                                    <Icon disabled={isInactive} name="mail outline" /><User user={usersList[x]} />
                                </List.Description>
                            </List.Content>
                        </List.Item>
                    </List>
                )}
                content={(
                    <div>
                        <p>Name: {usersList[x].first_name} {usersList[x].last_name}{usersList[x].id === user_id && " (me)"}</p>
                        <p>Email: {usersList[x].email}</p>
                    </div>
                )}
                inverted
            />
        ));
    }
    return users;
}

const User = ({ user }) => {
    return (
        <a href={`mailto:${user.email}`} className={!user.active ? 'UserAvatar--inactive' : ''}>{user.email}</a> 
    );
}

export default UserAvatar;
